module.exports = __webpack_public_path__ + "img/19.4640d653.png";